<template>
<div class="container container--wide">
	<div v-if="app.entries.length">
		<h1>Refuelling History <br>
		<small style="font-size: .5em;">For the past 12 months</small></h1>
		<el-collapse v-model="showArea" accordion>
			<el-collapse-item v-for="(entry, index) in app.entries" :key="index" :name="index">
				<template slot="title">
					<span v-html="generateTitle(entry)"></span>
				</template>
				<div class="responsive-table">
					<table style="width: 100%">
						<thead>
							<th>Refuelling amount</th>
							<th>Odometer reading</th>
							<th>Price</th>
							<th>Date</th>
							<th>&nbsp;</th>
						</thead>
						<tr v-for="(item, itemIndex) in entry.entries" :key="item.id">
							<td>
								{{ item.refuelling_amount }}kg
								<span v-if="app.user.vehicle_model === 'Symbio'">and {{ item.electricity_amount }}kWh</span>
							</td>
							<td>{{ item.odometer_reading.toLocaleString() }} {{ app.user.units }}</td>
							<td>{{ app.loadCurrencySymbol(app.user.currency) }}{{ item.price }}</td>
							<td>{{ formatDate(item.refueled_at) }}</td>
							<td style="text-align: right">
								<router-link :to="{ name: 'edit-entry', params: { id: item.id } }" tag="el-button">
									<i class="el-icon-edit"></i>
								</router-link>
							</td>
						</tr>
					</table>
				</div>
			</el-collapse-item>
		</el-collapse>
	</div>
	<div v-else>
		<h1>You currently don't have any entries to view.</h1>
		<hr>
		<p>You will be able to manage all your previous entries for the past 12 months from this page.</p>
		<p>
			<router-link :to="{ name: 'Dashboard' }" tag="el-button">
				Add entry
			</router-link>
		</p>
	</div>
</div>
</template>

<style lang="stylus" scoped>
	hr
		border none
		border-bottom 1px solid rgb(223, 228, 236)
		margin-bottom 2em
	h2
		opacity .4
		cursor pointer
		border-bottom 1px solid rgb(223, 228, 236)
		padding-bottom .5em
		transition opacity .2s ease
		&:hover
		&.active
			opacity 1

	table
		width 100%
		border-collapse collapse
		th
		td
			padding .5em 0
			border-bottom 1px solid rgb(223, 228, 236)

		th
			border-width 2px

		tr:last-child td
			border-bottom none

</style>

<script>
import format from "date-fns/format";
import { REPORT_URL } from "@/config";
import store from "@/utils/store";
import * as auth from "@/utils/auth";
import axios from "axios";
export default {
	name: "history",
	data() {
		return {
			app: store,
			showArea: 0
		};
	},
	methods: {
		formatDate(date) {
			return format(date, "Do MMMM, h:mma");
		},
		showTab(tabIndex) {
			this.showArea = "showArea-" + tabIndex;
			this.activeTab(tabIndex);
			return window.scrollTo(0, 0);
		},
		activeTab(tabIndex) {
			return this.showArea === "showArea-" + tabIndex;
		},
		generateTitle(entry) {
			let elecFuelled =
				this.app.user.vehicle_model === "Symbio"
					? ` - Total electricity charged: ${entry.electricity_charged}kWh `
					: "";
			let hydText = `Total hydrogen fuelled: ${entry.hydrogen_fuelled}kg`;
			let disText = ` - Total distance: ${entry.distance_driven.toLocaleString()} ${this
				.app.user.units}`;
			return `${entry.label} <small class="info">( ${hydText}${elecFuelled}${disText} )</small>`;
		}
	},
	created() {
		let _self = this;
		axios({
			method: "get",
			url: REPORT_URL,
			headers: {
				Authorization: `Bearer ${auth.getToken()}`
			}
		})
			.then(function(response) {
				auth.setToken(response.headers["x-new-token"]);
				return (_self.app.entries = response.data);
			})
			.catch(function(error) {
				auth.setToken(error.response.headers["x-new-token"]);
				try {
					auth.checkAuth(error);
				} catch (e) {
					return (_self.app.messages = ["Unable to load your data."]);
				}
			});
	}
};
</script>



// WEBPACK FOOTER //
// History.vue?54cd0cc5